import { createRouter, createWebHashHistory } from 'vue-router';
import HelloWorld from '@/components/HelloWorld.vue';
import ComicDetail from '@/views/ComicDetail.vue';
import Login from '@/views/Login.vue';
import Register from '@/views/Register.vue';
import UserCenter from '@/views/UserCenter.vue';
import Category from '@/views/Category.vue';
import Reader from '@/views/Reader.vue';
import AboutPage from '@/views/AboutPage.vue';
import PrivacyPage from '@/views/PrivacyPage.vue';
import StatementPage from '@/views/StatementPage.vue';
import SelfReviewPage from '@/views/SelfReviewPage.vue';
import AgreementPage from '@/views/AgreementPage.vue';
import YouthProtectionPage from '@/views/YouthProtectionPage.vue';
import FeedbackPage from '@/views/FeedbackPage.vue';
import { isLoggedIn } from '@/api/user';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld,
    meta: {
      title: '首页 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/comic/:id',
    name: 'ComicDetail',
    component: ComicDetail,
    props: true,
    meta: {
      title: '漫画详情 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: '注册 - 武汉天冉网络科技有限公司'  
    }
  },
  {
    path: '/user/center',
    name: 'UserCenter',
    component: UserCenter,
    meta: {
      requiresAuth: true,
      title: '个人中心 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/user/recharge',
    name: 'Recharge',
    component: () => import('@/views/Recharge.vue'),
    meta: {
      requiresAuth: true,
      title: '充值金币 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/vip',
    name: 'VIP',
    component: () => import('@/views/VipPage.vue'),
    meta: {
      requiresAuth: true,
      title: 'VIP会员 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/category',
    name: 'Category',
    component: Category,
    meta: {
      title: '分类 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/reader/:id',
    name: 'Reader',
    component: Reader,
    props: true,
    meta: {
      title: '阅读 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
    props: { type: 'about' },
    meta: {
      title: '关于我们 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: AboutPage,
    props: { type: 'contact' },
    meta: {
      title: '联系我们 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: AgreementPage,
    meta: {
      title: '用户协议 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPage,
    meta: {
      title: '隐私协议 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/statement',
    name: 'Statement',
    component: StatementPage,
    meta: {
      title: '网站声明 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/self-review',
    name: 'SelfReview',
    component: SelfReviewPage,
    meta: {
      title: '自审制度 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/youth-protection',
    name: 'YouthProtection',
    component: YouthProtectionPage,
    meta: {
      title: '青少年保护 - 武汉天冉网络科技有限公司'
    }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: FeedbackPage,
    meta: {
      title: '问题投稿 - 武汉天冉网络科技有限公司'
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

// 全局前置守卫，验证用户是否登录
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '武汉天冉网络科技有限公司';
  
  // 如果需要登录权限
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 如果未登录，重定向到登录页
    if (!isLoggedIn()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router; 